import { RpfGlobalNav } from '@raspberrypifoundation/rpf-global-nav/dist'
import PropTypes from 'prop-types'
import { signUpQueryParams, userManager } from '../../helpers/authentication'
import { useSelector } from 'react-redux'
import setUpHistory from '../../helpers/history'
import { withNamespaces } from 'react-i18next'
import { useCookies } from 'react-cookie'

import './GlobalNavBar.scss'

const GlobalNavBar = ({ i18n }) => {
  const [_cookies, _setCookie, removeCookie] = useCookies(['sessionProgress'])

  const isAuthenticated = useSelector((state) => {
    if (!state?.authentication) {
      return false
    }
    return state.authentication.user !== null
  })

  const authentication = useSelector((state) => state.authentication)

  const setAuthReturnUrl = () => {
    localStorage.setItem('authReturnUrl', window.location.href)
  }

  const onLogIn = () => {
    setAuthReturnUrl()
    userManager.signinRedirect()
  }

  const onLogOut = () => {
    removeCookie('sessionProgress', { path: '/' })
    userManager.signoutRedirect({
      id_token_hint: authentication?.user?.id_token,
    })
    userManager.removeUser()
  }

  const onSignUp = () => {
    setAuthReturnUrl()
    userManager.signinRedirect({ extraQueryParams: signUpQueryParams })
  }

  const handleLocaleSwitch = (newLocale) => {
    if (!newLocale) {
      return
    }

    let path = window.location.pathname.split('/')
    path[1] = newLocale
    path = path.join('/')

    setUpHistory(i18n).push({
      pathname: path,
    })
  }

  const locales = {
    en: { text: 'English' },
    'ar-SA': { text: 'اللغة العربية' },
    'ca-ES': { text: 'Català' },
    'cs-CZ': { text: 'Čeština' },
    'me-ME': { text: 'Crnogorski' },
    'cy-GB': { text: 'Cymraeg' },
    'da-DK': { text: 'Dansk' },
    'de-DE': { text: 'Deutsch' },
    'el-GR': { text: 'Ελληνικά' },
    'et-EE': { text: 'Eesti' },
    'es-ES': { text: 'Español' },
    'es-LA': { text: 'Español (Latinoamericano)' },
    'fr-FR': { text: 'Français' },
    'gu-IN': { text: 'ગુજરાતી' },
    'he-IL': { text: 'עברית' },
    'hi-IN': { text: 'हिन्दी' },
    'hr-HR': { text: 'Hrvatski' },
    'it-IT': { text: 'Italiano' },
    'ja-JP': { text: '日本語' },
    'kn-IN': { text: 'ಕನ್ನಡ' },
    'ko-KR': { text: '한국어' },
    'mr-IN': { text: 'मराठी' },
    'hu-HU': { text: 'Magyar' },
    'nl-NL': { text: 'Nederlands' },
    'no-NO': { text: 'Norsk' },
    'pl-PL': { text: 'Polski' },
    'pt-BR': { text: 'Português do Brasil' },
    'pt-PT': { text: 'Português' },
    'ro-RO': { text: 'Română' },
    'ru-RU': { text: 'Pусский' },
    'sk-SK': { text: 'Slovenčina' },
    'sl-SI': { text: 'Slovenščina' },
    'fi-FI': { text: 'Suomi' },
    'sv-SE': { text: 'Svenska' },
    'vls-BE': { text: 'Vlaams' },
    'sr-SP': { text: 'Српски' },
    'tr-TR': { text: 'Türkçe' },
    'uk-UA': { text: 'Українська' },
    'xh-ZA': { text: 'IsiXhosa' },
    'zh-CN': { text: '简体中文' },
    'zh-TW': { text: '繁體中文' },
  }

  return (
    <div className="global-nav-bar">
      <RpfGlobalNav
        locale={i18n.language}
        locales={locales}
        onSelectLanguage={handleLocaleSwitch}
        loggedIn={isAuthenticated}
        onLogIn={onLogIn}
        onLogOut={onLogOut}
        onSignUp={onSignUp}
        theme="dark"
      />
    </div>
  )
}

GlobalNavBar.propTypes = {
  i18n: PropTypes.object.isRequired,
}

export default withNamespaces('translations')(GlobalNavBar)
